import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import StatsBox from '../../components/shared/StatsBox';
import CasesIcon from '@mui/icons-material/MedicalServicesOutlined';
import FutureCasesIcon from '@mui/icons-material/NextWeekOutlined';
import PostponedCasesIcon from '@mui/icons-material/DoNotDisturbAltOutlined';

import { CasesTableContainer } from '../../components/cases';

import { toggleSidebar } from '../../actions/sidebarActions';
import { fetchCaseStats } from '../../actions/casesActions';

import './cases-page.scss';

const CasesPage = ({ fetchCaseStats, totalCases, futureCases, postponedCases, trainingMode, currentUserId }) => {
  useEffect(() => {
    fetchCaseStats();
  }, [fetchCaseStats, trainingMode, currentUserId]);

  return (
    <div className="cases-page">
      <Grid container spacing={3} sx={{ mb: 3, display: { xs: 'none', md: 'flex' } }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <StatsBox title='Total Cases' number={totalCases} icon={<CasesIcon />} />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <StatsBox title='Future Cases' number={futureCases} icon={<FutureCasesIcon />} />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <StatsBox title='Postponed Cases' number={postponedCases} icon={<PostponedCasesIcon />} />
        </Grid>
      </Grid>
      <CasesTableContainer withButton />
    </div>
  );
};

CasesPage.propTypes = {
  casesLoading: PropTypes.bool,
  casesLoaded: PropTypes.bool,
  toggleSidebar: PropTypes.func,
  fetchCaseStats: PropTypes.func,
};

const mapStateToProps = (state) => ({
  casesLoading: state.cases.loading,
  casesLoaded: state.cases.isLoaded,
  totalCases: state.cases.stats.totalCases,
  futureCases: state.cases.stats.futureCases,
  postponedCases: state.cases.stats.postponedCases,
  trainingMode: state.sidebar.trainingMode,
  currentUserId: state.user.currentUser?.uid,
});

const mapDispatchToProps = (dispatch) => ({
  toggleSidebar: () => dispatch(toggleSidebar()),
  fetchCaseStats: () => dispatch(fetchCaseStats()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CasesPage);
